/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 메뉴아이템을 타입에 따라 정의한다.
 *
 * @file /src/models/table/Filters.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 6. 3.
 */
import * as filter from './filters/Filter';
import * as text from './filters/Text';
import * as number from './filters/Number';
import * as date from './filters/Date';
import * as list from './filters/List';

export type Properties = text.Properties | number.Properties | date.Properties | list.Properties;

export { filter };

export class Filters {
    /**
     * 필터 초기설정을 받아 적절하게 필터객체를 초기화한다.
     *
     * @param properties - 필터설정
     * @returns 필터객체
     */
    static get(properties: Properties): filter.Filter {
        if (properties === null) {
            return null;
        }

        switch (properties.type) {
            case 'text':
                return new text.Text(properties);

            case 'number':
                return new number.Number(properties);

            case 'date':
                return new date.Date(properties);

            case 'list':
                return new list.List(properties);
        }
    }
}
